import API from '../../apis';
import { action, generateErrorAction } from '../actions';
import actionTypes from './actionTypes';

export const getList = query => {
  const request = () => {
    return dispatch => {
      dispatch(loading());
      return API.invoiceAdditions
        .getList(query)
        .then(res => dispatch(success(res)))
        .catch(err => {
          dispatch(
            generateErrorAction(err, {
              failure: actionTypes.GET_INVOICE_ADDITIONS_LIST_FAILED,
              reject: actionTypes.GET_INVOICE_ADDITIONS_LIST_REJECT
            })
          );
          throw err;
        });
    };
  };
  const loading = () => action(actionTypes.GET_INVOICE_ADDITIONS_LIST_LOADING);
  const success = res => action(actionTypes.GET_INVOICE_ADDITIONS_LIST_SUCCESS, res);

  return request();
};

export const toggleStatus = (id, isActive) => {
  const request = () => {
    return dispatch => {
      dispatch(loading());
      return API.invoiceAdditions
        .toggleStatus(id, isActive)
        .then(res => dispatch(success(res)))
        .catch(err => {
          dispatch(
            generateErrorAction(err, {
              failure: actionTypes.TOGGLE_INVOICE_ADDITION_STATUS_FAILED,
              reject: actionTypes.TOGGLE_INVOICE_ADDITION_STATUS_REJECT
            })
          );
          throw err;
        });
    };
  };
  const loading = () => action(actionTypes.TOGGLE_INVOICE_ADDITION_STATUS_LOADING);
  const success = res => action(actionTypes.TOGGLE_INVOICE_ADDITION_STATUS_SUCCESS, res);

  return request();
};

export const add = data => {
  const request = () => {
    return dispatch => {
      dispatch(loading());
      return API.invoiceAdditions
        .add(data)
        .then(res => dispatch(success(res)))
        .catch(err => {
          dispatch(
            generateErrorAction(err, {
              failure: actionTypes.CREATE_INVOICE_ADDITION_FAILED,
              reject: actionTypes.CREATE_INVOICE_ADDITION_REJECT
            })
          );
          throw err;
        });
    };
  };
  const loading = () => action(actionTypes.CREATE_INVOICE_ADDITION_LOADING);
  const success = res => action(actionTypes.CREATE_INVOICE_ADDITION_SUCCESS, res);

  return request();
};

export const remove = id => {
  const request = () => {
    return dispatch => {
      dispatch(loading());
      return API.invoiceAdditions
        .remove(id)
        .then(res => dispatch(success(res)))
        .catch(err => {
          dispatch(
            generateErrorAction(err, {
              failure: actionTypes.DELETE_INVOICE_ADDITION_FAILED,
              reject: actionTypes.DELETE_INVOICE_ADDITION_REJECT
            })
          );
          throw err;
        });
    };
  };
  const loading = () => action(actionTypes.DELETE_INVOICE_ADDITION_LOADING);
  const success = res => action(actionTypes.DELETE_INVOICE_ADDITION_SUCCESS, res);

  return request();
};

export const getDeletedInvoiceAdditionsList = query => {
  const request = () => {
    return dispatch => {
      dispatch(loading());
      return API.invoices
        .getDeletedInvoiceAdditionsList(query)
        .then(res => dispatch(success(res)))
        .catch(err => {
          dispatch(
            generateErrorAction(err, {
              failure: actionTypes.GET_DELETED_INVOICE_ADDITIONS_FAILED,
              reject: actionTypes.GET_DELETED_INVOICE_ADDITIONS_REJECT
            })
          );
          throw err;
        });
    };
  };
  const loading = () => action(actionTypes.GET_DELETED_INVOICE_ADDITIONS_LOADING);
  const success = res => action(actionTypes.GET_DELETED_INVOICE_ADDITIONS_SUCCESS, res);

  return request();
};
